import { render, staticRenderFns } from "./Padrao.vue?vue&type=template&id=1824aab2"
import script from "./Padrao.vue?vue&type=script&lang=js"
export * from "./Padrao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports